import { useEffect, useState } from 'react';
import clickDown from '../assets/click_down.m4a';
import clickUp from '../assets/click_up.m4a';
import { darkenHSL } from '../util.js';
import './oval_button.css';

const soundDown = new Audio(clickDown);
const soundUp = new Audio(clickUp);

const OvalButton = ({ height, width, bgColor, content, imageContent, onMouseDown, onMouseUp }) => {

    const [borderColor, setBorderColor] = useState(darkenHSL(bgColor, 0.4));

    useEffect(() => {
        setBorderColor(darkenHSL(bgColor, 0.4))
    }, [bgColor])
    
    function handleMouseDown() {
        soundDown.play();
        onMouseDown();
    };

    function handleMouseUp() {
        soundUp.play();
        onMouseUp();
    }
  
    return (
        <div className={`oval ${height ? 'big' : 'small' }`}
            style={{
                height: height ?? '100px',
                width: width ?? '300px',
                backgroundColor: bgColor,
                border: `3px solid ${borderColor}`,
            }} 
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}>
        {imageContent &&
            <img src={imageContent} alt="Oval Content" />}
        {content && <span>{content}</span>}
      </div>
    );
};

export default OvalButton;